// extracted by mini-css-extract-plugin
export default {"postReport":"PostReport_postReport__2TydN","contentTitle":"PostReport_contentTitle__cAJ-F","content":"PostReport_content__jrD1U","backButton":"PostReport_backButton__0Mwro"};